import React, { memo } from "react";
import Box from "../../box/Box";
import HyperLink from "../../widgets/HyperLink";
import Reference from "../../widgets/Reference";

const CountryLevelInfluenceBox = () => (
  <Box reference="Box 1.1">
    <h4 className="figure-title-only">Influence at the Country Level</h4>

    <p>
      The individual countries that make up each GNI group vary greatly in
      population size and contraceptive use (mCPR). Cumulatively, 49% of all
      users live in just four countries: India (30%), Brazil (8%), Indonesia
      (7%), and Bangladesh (5%). By contrast, 116 countries in the global market
      each account for less than 1% of the total number of users. Government
      programs and policies, cultural norms, market strength, and other factors
      influence the level and type of contraceptive use in each country. As we
      observe patterns in the global market, we should keep in mind that in some
      cases just a few countries carry the same weight as the other 131
      countries combined.
    </p>
    <p>
      The spending pattern in upper-middle-income countries is largely
      influenced by Brazil where private sector users of injectables, pills, and
      condoms dominate the market (60% of all users). Recent studies have
      suggested that limited availability of IUDs and implants in the public
      sector, and even the private sector, have contributed to this method skew.
      <Reference marker="&ast;" maxWidth={500}>
        See Bahamondes, Luis, Fernandes, Arlete, & Monteiro, Ilza. (2017).
        Barriers to Implementing and Consolidating a Family Planning Program
        that would meet Brazilian Needs. Revista Brasileira de Ginecologia e
        Obstetrícia, 39(8), 373&ndash;375.{" "}
        <HyperLink href="https://dx.doi.org/10.1055/s-0037-1604423">
          https://dx.doi.org/10.1055/s-0037-1604423
        </HyperLink>{" "}
        and Sora Yasri, Viroj Wiwanitkit. (2017) Contraceptive sales after the
        Zika epidemic. The European Journal of Contraception & Reproductive
        Health Care 22:6, pages 479&ndash;479.{" "}
        <HyperLink href="https://www.tandfonline.com/doi/full/10.1080/13625187.2017.1397623">
          https://www.tandfonline.com/doi/full/10.1080/13625187.2017.1397623
        </HyperLink>
      </Reference>
    </p>
  </Box>
);

export default memo(CountryLevelInfluenceBox);
